import { render } from "./KryptonWalletCardList.vue?vue&type=template&id=0b576675&lang=pug"
import script from "./KryptonWalletCardList.vue?vue&type=script&lang=js"
export * from "./KryptonWalletCardList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__